var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHairStyling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_Shipping") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MVP/20",
    transform: "translate(-291.000000, -328.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selectable-Card-Copy",
    transform: "translate(252.000000, 307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(5.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_Shipping",
    transform: "translate(34.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4331308,0 C8.8565389,0 9.199779,0.3357864 9.199779,0.75 L9.199779,0.75 L9.199,18.252 L15.6359445,4.249 L15.6508168,4.210927 C15.7063538,4.052634 15.7061609,3.8806396 15.6502688,3.7224662 L15.6336446,3.6796913 C15.561624,3.510128 15.4287664,3.3728127 15.2609441,3.2929894 L15.2182751,3.2742459 L10.966955,1.5572459 C10.575587,1.3991824 10.3893008,0.9606698 10.550873,0.5778006 C10.7072332,0.2072821 11.1320709,0.0246568 11.5140193,0.1565153 L11.5520597,0.1707541 L15.8034007,1.8877625 C16.3672411,2.1155024 16.8155049,2.5530433 17.0495719,3.1041241 C17.2742762,3.6331618 17.2839049,4.2252317 17.0783228,4.7597555 L17.0515041,4.8262625 L17.0421182,4.8475586 L10.114,19.921 L21.221233,10.6772 L21.249612,10.6504372 C21.368894,10.5304766 21.443757,10.3748572 21.46222,10.2084801 L21.465849,10.1628565 C21.474696,9.9794449 21.41446,9.7997939 21.297566,9.6575816 L21.267169,9.622828 L18.1709325,6.294828 C17.8859347,5.9884973 17.9087409,5.514148 18.2218715,5.2353392 C18.5242044,4.9661444 18.9866451,4.9776606 19.2746982,5.2544964 L19.3048785,5.285172 L22.401187,8.6132491 C22.811716,9.0546309 23.026196,9.6374783 22.997441,10.2335659 C22.969792,10.8067271 22.719436,11.3469829 22.299109,11.7447127 L22.247857,11.7917491 L22.228695,11.8082428 L9.199,22.651 L9.199779,23.25 C9.199779,23.6296958 8.911362,23.943491 8.5371604,23.9931534 L8.4331308,24 L0.7666483,24 C0.3432401,24 0,23.6642136 0,23.25 L0,23.25 L0,0.75 C0,0.3357864 0.3432401,0 0.7666483,0 L0.7666483,0 L8.4331308,0 Z M7.666,15 L1.533,15 L1.5332965,22.5 L7.4879198,22.5001145 C7.4765164,22.312605 7.5369564,22.1227892 7.6657555,21.9729362 L7.666,15 Z M4.6450448,18.7508514 C5.259227,18.7740514 5.7498619,19.268473 5.7498619,19.875 C5.7498619,20.4963203 5.2350017,21 4.5998895,21 C3.9647773,21 3.4499171,20.4963203 3.4499171,19.875 C3.4499171,19.268473 3.940552,18.7740514 4.5547342,18.7508514 L4.6450448,18.7508514 Z M7.666,10.5 L1.533,10.5 L1.533,13.5 L7.666,13.5 L7.666,10.5 Z M7.666,6 L1.533,6 L1.533,9 L7.666,9 L7.666,6 Z M7.6664825,1.5 L1.5332965,1.5 L1.533,4.5 L7.666,4.5 L7.6664825,1.5 Z",
    id: "Icon-Color"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairStyling);
export default __webpack_public_path__ + "static/media/hair-styling.85c8ccb8b6f3e943e33bae186caa5484.svg";
export { ForwardRef as ReactComponent };